var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"check-animate",attrs:{"src":require('./check-animate.gif')}})
}
var staticRenderFns = []

export { render, staticRenderFns }